module.exports = __webpack_public_path__ + "img/1718763391209-17187632118944783719785518104542.jpg.289f0249.webp";